import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-policy',
  templateUrl: './terms-policy.component.html',
  styleUrls: ['./terms-policy.component.scss']
})
export class TermsPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
